export function getComponentPropsFromTheme(context, key) {
  if (!context || !context.theme) {
    return {};
  }
  return context.theme[key] || {};
}
